
import Vue from "vue";
import uuid4 from "uuid4";
import { removeTags } from "../utils";

export default Vue.extend({
	data() {
		return {
			innerValue: this.value || "",
			id: "",
			showpicker: false,
			colors: ["black","red","green","blue","orange","pink"],
			savedSelection: null as null | Range
		};
	},
	props: {
		value: String,
		height: String,
	},
	methods: {
		// eslint-disable-next-line max-lines-per-function
		onKeyDown(event:KeyboardEvent){
			if (event.key === "Enter") {
				const selection = window.getSelection();
				if (!selection) return;
				const range = selection.getRangeAt(0);
				const currentNode:any = range.startContainer;
				const offset = range.startOffset;

				if (currentNode.nodeType === Node.TEXT_NODE) {
					const textAfterCursor = (currentNode.textContent || "").slice(offset);

					const listItem = currentNode.parentElement;
					if (listItem && listItem.tagName === "LI" && textAfterCursor.trim() === "") {
						event.preventDefault();

						const newListItem = document.createElement("li");
						newListItem.textContent = "\u200B";
						listItem.parentNode.insertBefore(newListItem, listItem.nextSibling);

						const newRange = document.createRange();
						newRange.setStart(newListItem, 0);
						newRange.collapse(true);
						selection.removeAllRanges();
						selection.addRange(newRange);
					}else {
						document.execCommand("insertLineBreak");
					}
				} else if (currentNode.tagName === "LI" && offset + 1 === (currentNode.childNodes.length)) {

					event.preventDefault();
					const newRange = document.createRange();
					newRange.setStartAfter(currentNode.parentElement);
					newRange.collapse(true);
					selection.removeAllRanges();
					selection.addRange(newRange);
					currentNode.remove();
					document.execCommand("insertLineBreak");
				} else{
					console.log(currentNode.tagName);
					console.log(offset,currentNode.childNodes.length);
					document.execCommand("insertLineBreak");
				}
				event.preventDefault();
			}
			if (event.key === "Tab") {
				event.preventDefault();
				document.execCommand("insertHTML", false, "\u00a0\u00a0\u00a0\u00a0");
			}
		},
		onInput() {
			if (!this.$refs.mainEl) return;
			let content = (this.$refs.mainEl as HTMLDivElement).innerHTML;
			console.log(content);
			this.innerValue = content;
			this.$emit("input", content);
		},
		applyBold() {
			document.execCommand("bold");
			this.onInput();
		},
		applyItalic() {
			document.execCommand("italic");
			this.onInput();
		},
		applyUnderline() {
			document.execCommand("underline");
			this.onInput();
		},
		applyHeading() {
			document.execCommand("formatBlock", false, "<h1>");
			this.onInput();
		},
		applyUl() {
			document.execCommand("insertUnorderedList");
			this.onInput();
		},
		applyOl() {
			document.execCommand("insertOrderedList");
			this.onInput();
		},
		undo() {
			document.execCommand("undo");
			this.onInput();
		},
		redo() {
			document.execCommand("redo");
			this.onInput();
		},
		tab() {
			document.execCommand("indent", false, undefined);
			this.onInput();
		},
		untab() {
			document.execCommand("outdent", false, undefined);
			this.onInput();
		},
		saveSelection() {
			if (window.getSelection) {
				const selection = window.getSelection();

				if(!selection)
					return;

				if (selection.rangeCount > 0) {
					this.savedSelection = selection.getRangeAt(0);
				}
			}
		},
		restoreSelection() {
			if (this.savedSelection) {
				const selection = window.getSelection();

				if(!selection)
					return;

				selection.removeAllRanges();
				selection.addRange(this.savedSelection);
			}
		},
		togglePicker(){
			this.showpicker=!this.showpicker;
			this.$nextTick(() => {
				this.restoreSelection();
			});
		},
		setColor(e:any,color:string) {
			e.preventDefault();
			document.execCommand("foreColor", false, color);
			this.showpicker = false;
			this.onInput();
		},
		onPaste(e:ClipboardEvent){
			e.preventDefault();
			if (!e.clipboardData) return;
			let text = e.clipboardData.getData("text/plain");
			document.execCommand("insertHTML", false, text.replace(/(?:\r\n|\r|\n)/g, "<br>"));
			this.onInput();
		},
		clean(e:string):string{
			return removeTags(e.replaceAll("{__NEW_LINE__}", "<br>").replaceAll("{__DOUBLE_SPACE__}", "&nbsp;&nbsp;"));
		},
		updateCursorPosition(){
			const selection = window.getSelection();
			if (!selection) return;
			const range = selection.getRangeAt(0);
			const offset = range.startOffset;
			this.$emit("cursor-position", offset);
		},
		onKeyUp(){
			this.updateCursorPosition();
			this.onInput();
		},
		onMouseUp(){
			this.updateCursorPosition();
			this.onInput();
		},
		onFocus(){
			this.updateCursorPosition();
			this.$emit("focus");
		},
	},
	mounted() {
		if(this.value){
			this.innerValue = this.clean(this.value);
		}
		let el = this.$refs.mainEl as HTMLDivElement;
		if (!el) {
			console.log("No main el");
			return;
		}
		(this.$refs.mainEl as HTMLDivElement).innerHTML = this.innerValue;
		el.addEventListener("paste", this.onPaste);
	},
	created(){
		this.id=uuid4();
	}
});
